/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ZohoServiceDeskBudgetAlertMapping {
    getFixupPrototypeFunction() { return ZohoServiceDeskBudgetAlertMapping.fixupPrototype; }

    static newInstance(model: Partial<ZohoServiceDeskBudgetAlertMapping>): ZohoServiceDeskBudgetAlertMapping {
        let obj = Object.assign(new ZohoServiceDeskBudgetAlertMapping(), model);
        ZohoServiceDeskBudgetAlertMapping.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ZohoServiceDeskBudgetAlertMapping>): ZohoServiceDeskBudgetAlertMapping {
        if (!model) return null;
        return ZohoServiceDeskBudgetAlertMapping.newInstance(<ZohoServiceDeskBudgetAlertMapping> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ZohoServiceDeskBudgetAlertMapping) {
        if (!obj) return;

        models.ZohoServiceDeskBudgetAlertMapping.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ZohoServiceDeskBudgetAlertMapping): boolean {
        Object.setPrototypeOf(obj, ZohoServiceDeskBudgetAlertMapping.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    selected_description_attributes: Array<models.ZohoServiceDeskBudgetAlertDescriptionAttribute>;

    selected_incident_attributes: Array<models.ZohoServiceDeskBudgetAlertIncidentAttribute>;

}
